<template>
    <div class="find-and-delete">
        <h1 class="title mb-2">Nutzer suchen und löschen</h1>
        <v-form v-model="valid" ref="searchUserForm" v-on:submit.prevent>
            <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-Mail"
                    :disabled="loading"
                    @keyup.enter="search"
                    class="mb-2"
            ></v-text-field>
        </v-form>
        <div>
            <v-btn
                class="drei_60-btn"
                outlined
                @click="search"
                block
                :loading="searching"
                :disabled="!valid || loading"
            >
                Suchen
            </v-btn>
        </div>
        <h1 class="mt-5 title" v-if="searchedEmail.length && (evalanche.profileId || celeraone.ssoId)">
            <span class="font-weight-regular">Suchergebnisse für </span>{{ this.searchedEmail }}
        </h1>
        <v-form
            v-model="deleteValid"
            v-if="searchedEmail.length"
            class="mt-2"
            ref="deleteUserForm"
        >
            <v-switch
                color="success"
                v-if="celeraone.ssoId"
                @change="validateDeleteUserForm"
                :disabled="deleting"
                :rules="deleteInCeleraoneRules"
                v-model="deleteInCeleraone"
            >
                <div slot="label">
                    <div class="caption">Celeraone</div>
                    <div>
                        <span class="body-1">SSO ID:</span>
                        &nbsp;
                        <span class="body-2">{{ celeraone.ssoId || '' }}</span>
                    </div>
                </div>
            </v-switch>
            <v-switch
                color="success"
                v-if="evalanche.profileId"
                @change="validateDeleteUserForm"
                :rules="deleteInEvalancheRules"
                :disabled="deleting"
                v-model="deleteInEvalanche"
            >
                <div slot="label">
                    <div class="caption">Evalanche</div>
                    <div>
                        <span class="body-1">Profile ID:</span>
                        &nbsp;
                        <span class="body-2">{{ evalanche.profileId || '' }}</span>
                    </div>
                </div>
            </v-switch>
            <v-switch
                color="success"
                v-if="salesforce.status"
                @change="validateDeleteUserForm"
                :disabled="deleting"
                :rules="deleteInSalesforceRules"
                v-model="deleteInSalesforce"
            >
                <div slot="label">
                    <div class="caption">Salesforce</div>
                    <div>
                        <span class="body-1">SSO ID:</span>
                        &nbsp;
                        <span class="body-2">{{ salesforce.ssoId || '' }}</span>
                    </div>
                </div>
            </v-switch>
        </v-form>
        <div v-if="searchedEmail.length && (evalanche.profileId || celeraone.ssoId)" class="mt-2">
            <v-btn
                color="error"
                outlined
                @click="showDialog = true"
                block
                :loading="deleting"
                :disabled="!deleteValid || loading"
            >
                Löschen
            </v-btn>
        </div>
        <v-dialog
            v-model="showDialog"
            max-width="500"
            persistent
            class="flex-none"
        >
            <v-card>
                <v-card-title
                    class="headline"
                    primary-title
                >
                    Benutzer löschen
                </v-card-title>
                <v-card-text>
                    <p class="body-1">
                        Soll der Benutzer mit der Email
                        <span class="body-2">{{ email }}</span>
                        wirklich gelöscht werden?
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="warning"
                        outlined
                        @click="showDialog = false"
                        :disabled="!deleteValid || loading"
                    >Abbrechen</v-btn>
                    <v-btn
                        color="error"
                        outlined
                        :loading="deleting"
                        :disabled="!deleteValid || loading"
                        @click="deleteUser"
                    >
                        Unwiderruflich Löschen
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Api from '@/api';

export default {
    name: 'FindAndDelete',
    props: ['instantEmailSearch'],
    data() {
        return {
            valid: false,
            deleteValid: false,
            deleteInCeleraone: false,
            deleteInSalesforce: false,
            deleteInEvalanche: false,
            deleteInCeleraoneRules: [
                v => (v || this.deleteInEvalanche || this.deleteInSalesforce) || '',
            ],
            deleteInSalesforceRules: [
                v => (v || this.deleteInEvalanche || this.deleteInCeleraone) || '',
            ],
            deleteInEvalancheRules: [
                v => (v || this.deleteInCeleraone || this.deleteInSalesforce) || '',
            ],
            loading: false,
            searching: false,
            deleting: false,
            showDialog: false,
            email: '',
            searchedEmail: '',
            evalanche: {},
            celeraone: {},
            salesforce: {},
            emailRules: [
                v => !!v || 'Email darf nicht leer sein.',
                v => (v.trim().length <= 0 || /.+@.+/.test(v)) || 'E-mail muss gültig sein.',
            ],
        };
    },
    watch: {
        instantEmailSearch(newValue) {
            if (!(this.searching || this.loading) && typeof newValue === 'string') {
                this.email = newValue;
                if (!this.emailRules.map(fn => fn(newValue)).filter(v => v !== true).length) {
                    this.valid = true;
                    this.search();
                }
            }
        },
    },
    methods: {
        validateDeleteUserForm() {
            this.$refs.deleteUserForm.validate();
        },
        deleteUser() {
            if (!this.deleteValid) {
                return;
            }
            this.loading = true;
            this.deleting = true;
            Api.devtool.deleteUserByMail(this.searchedEmail, {
                inEvalanche: this.deleteInEvalanche,
                inCeleraone: this.deleteInCeleraone,
                inSalesforce: this.deleteInSalesforce,
            }).then(({ data }) => {
                this.evalanche = {};
                this.celeraone = {};
                this.salesforce = {};
                const failedIn = [];
                if (data.inEvalanche !== this.deleteInEvalanche) {
                    failedIn.push('Evalanche');
                }
                if (data.inCeleraone !== this.deleteInCeleraone) {
                    failedIn.push('Celeraone');
                }
                if (data.inSalesforce !== this.deleteInSalesforce) {
                    failedIn.push('Salesforce');
                }
                if (failedIn.length) {
                    this.$store.commit(
                        'snackbar/error',
                        /* eslint-disable-next-line */
                        `Fehler beim Löschen des Nutzers in folgenden Systemen: ${failedIn.join(', ')}.`
                    );
                } else {
                    this.$store.commit('snackbar/success', 'Der Nutzer wurde erfolgreich gelöscht.');
                }
            }).catch(() => {
                this.$store.commit('snackbar/error', 'Fehler beim Löschen des Nutzers.');
            }).finally(() => {
                this.loading = false;
                this.deleting = false;
                this.showDialog = false;
            });
        },
        search() {
            if (!this.valid) {
                return;
            }
            this.celeraone = {};
            this.evalanche = {};
            this.salesforce = {};
            this.deleteInCeleraone = false;
            this.deleteInSalesforce = false;
            this.deleteInEvalanche = false;
            this.deleteValid = false;
            this.loading = true;
            this.searching = true;
            this.searchedEmail = this.email;
            Api.devtool.findUserByMail(this.email)
                .then(({ data }) => {
                    if (!data.celeraone && !data.evalanche) {
                        this.$store.commit('snackbar/success', 'Kein Nutzer gefunden.');
                    }
                    if (data.celeraone) {
                        this.celeraone = {
                            ssoId: data.celeraone.user.user_id,
                        };
                        this.deleteInCeleraone = true;
                    }
                    if (data.salesforce) {
                        this.salesforce = {
                            status: data.salesforce.status,
                            ssoId: data.salesforce.ssoId,
                        };
                        this.deleteInSalesforce = true;
                    }
                    if (data.evalanche) {
                        this.evalanche = {
                            profileId: data.evalanche.PROFILEID,
                        };
                        this.deleteInEvalanche = true;
                    }
                }).catch(() => {
                    this.$store.commit('snackbar/error', 'Es wurde kein Nutzer zu dieser Email gefunden.');
                }).finally(() => {
                    this.loading = false;
                    this.searching = false;
                });
        },
    },
};
</script>

<style scoped lang="scss"></style>
